import { useQuery } from '@tanstack/react-query';

import { KEYS_QUERY } from 'common/constants';
import useService from 'common/hook/useService';
import { handleException } from 'modules/account/detail/helpers/utils';

import type { ReplaceGeneralDetails } from 'modules/suppliers/types';

/** UC3 — Chi tiết HSNL NCC toàn hệ thống theo id HSNL (Thông tin chung + Loại hàng hóa). */
const useQuickSearchSupplierDetail = (id?: number) => {
  const service = useService();

  return useQuery({
    queryKey: [KEYS_QUERY.qsSupplierDetail, id],
    queryFn: async (): Promise<ReplaceGeneralDetails | null> => {
      try {
        if (!service || !id) return null;
        return await service.QuickSearchController_getSupplier({ params: { id } });
      } catch (error) {
        handleException(error);
        return null;
      }
    },
    enabled: !!service && !!id,
  });
};

export default useQuickSearchSupplierDetail;
